import FooterWrapper from "@/components/footer/FooterWrapper";
import NavItemClient from "./NavItem";
import type { Route } from "@deskpro-product/messenger-api-schemas/messenger/config/routes";
import clsx from "clsx";
import FooterClient from "./FooterClient";
import { PoweredBy } from "./PoweredBy";
import { useTranslations } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/TranslationContext";
import type { MessengerConfig } from "@deskpro-product/messenger-api-schemas/messenger/config";
import { useLauncherStore } from "../../../lib/client/contexts/LauncherStoreContext";
import { hasViewPermission } from "../../lib/client/utils/hasViewPermission";
import { useSessionContext } from "../../lib/client/contexts/SessionContext";
import { routeTranslationMap } from "../../lib/client/utils/routeTranslationMap";

export default function Footer({
  hidePoweredBy,
  params,
}: {
  hidePoweredBy?: boolean;
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
}) {
  const { session } = useSessionContext();
  const config = useLauncherStore((state) => state.config);
  const routes = config?.routes?.filter((route) => {
    return (
      route.type === "HomeRoute" ||
      hasViewPermission(session?.user?.usergroupIds || [], route.permissions)
    );
  });
  const hideNav = config?.mode === "messenger-only" || !routes || routes.length < 2;

  return hideNav && hidePoweredBy ? null : (
    <FooterClient>
      <FooterWrapper>
        {!hideNav && <Nav params={params} routes={routes} />}
        {!hidePoweredBy && <PoweredBy />}
      </FooterWrapper>
    </FooterClient>
  );
}

const Nav = ({
  params,
  routes,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
  routes: NonNullable<MessengerConfig["routes"]>;
}) => {
  return (
    <nav className={clsx("flex h-[80px] w-full items-center justify-between")}>
      {routes.map((route, i) => (
        <NavItem key={i} route={route} params={params} />
      ))}
    </nav>
  );
};

const NavItem = ({
  params,
  route,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
  route: Route;
}) => {
  const t = useTranslations();
  return <NavItemClient route={route} params={params} title={t(routeTranslationMap[route.type])} />;
};
